import lang from "quasar/lang/uk.js"
import iconSet from "quasar/icon-set/mdi-v7.js"
import { Notify } from "quasar"


export const componentsWithDefaults = {  }

export const appConfigKey = "nuxtQuasar"

export const quasarNuxtConfig = {
  lang,
  iconSet,
  components: {"defaults":{},"autoImport":true},
  plugins: {Notify},
  
}